import { Injectable } from '@angular/core';
import { ModalOptions } from './modalOptions.model';

@Injectable()
export class ModalService {
  modalVisibility: 'visible' | 'invisible' = 'invisible';
  type: string;
  callback;
  data;

  getModalState(): 'visible' | 'invisible' {
    return this.modalVisibility;
  }

  getModalType(): string {
    return this.type;
  }

  getModalData() {
    return this.data;
  }

  openModal(options: ModalOptions): void {
    this.type = options.type;
    this.data = options.data;
    this.callback = options.callback;
    this.modalVisibility = 'visible';
  }

  closeModal(): void {
    this.modalVisibility = 'invisible';
    this.type = null;
    this.callback = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/ModalService/ModalService.ts